import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import BettingPanel from "../../components/ChainReactionGame/BettingPanel";
import { setGameBet, setGameBetLock, setGameHintStatus, setGameRevealAllAnswersStatus, setGameQuitStatus, setShouldRewardPoints, setGameRevealAllAnswersClickStatus, setGameInstrOverlayStatus, GAME_STATUS_INSTR_OVERLAY, setGameStatus, GAME_STATUS_REVEAL_ALL_ANSWERS } from "../../actions/game";
import { playSound } from "../../utils/audio-helper";

class BettingContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

    this.addBet = this.addBet.bind(this);
    this.reduceBet = this.reduceBet.bind(this);
    this.setBet = this.setBet.bind(this);
    this.placeBet = this.placeBet.bind(this);
    this.revealAnswer = this.revealAnswer.bind(this);
    this.reloadPoints = this.reloadPoints.bind(this);
    this.showHint = this.showHint.bind(this);
    this.quitGame = this.quitGame.bind(this);
  }

  addBet(num, maxBet) {
    const self = this,
    {
      bet,
      points,
      setGameBet,
      betLocked
    } = self.props;

    return evt=>{
      console.log('addBet', num, maxBet);
      if ((maxBet === undefined || num <= maxBet) && num<=points && bet===0 && !betLocked) {
        setGameBet(bet + num);
      }
    }
  }

  setBet(num) {
    const {
      setGameBet,
      betLocked
    } = this.props;

    return evt=> {
      if (!betLocked) {
        setGameBet(num);
      }
    }
  }

  reduceBet(num) {
    const {
      bet,
      setGameBet,
      betLocked
    } = this.props;

    return evt=> {

      if (bet >= num && !betLocked) {
        setGameBet(bet - num);
      }
    }
  }

  placeBet() {
    const {
      bet,
      betLocked,
      focusLinkIndex
    } = this.props,
    hasChainLinkSelected = focusLinkIndex !== null,
    hasBet = bet > 0;

    if (hasBet && !betLocked && hasChainLinkSelected) {
      this.props.setGameBetLock();
    }
  }

  revealAnswer() {
    this.props.setGameRevealAllAnswersClickStatus();
  }

  quitGame() {
    this.props.setGameQuitStatus();
  }

  reloadPoints() {
    this.props.setShouldRewardPoints(true);
  }

  showHint() {
    if (this.props.focusLinkIndex !== null && this.props.isAllowHintOnFocusLink) {
      this.props.setGameHintStatus();
    }
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState) {
    const {
          bet,
          betLocked,
          focusLinkIndex
        } = this.props,
    hasChainLinkSelected = focusLinkIndex !== null,
    hasBet = bet > 0;

    if (hasBet && hasChainLinkSelected && !betLocked) {
      this.props.setGameBetLock();
      playSound(this.props.sounds, 'wager');
    }
  }

  render() {
    return (
      <BettingPanel
        addBet={this.addBet}
        setBet={this.setBet}
        revealAnswer={this.revealAnswer}
        quitGame={this.quitGame}
        betLocked={this.props.betLocked}
        bet={this.props.bet}
        points={this.props.points}
        isLinkSelected={this.props.focusLinkIndex !== null}
        isAllowHintOnFocusLink={this.props.isAllowHintOnFocusLink}
        reloadPoints={this.reloadPoints}
        showHint={this.showHint}
        setGameResetStatus={this.props.setGameResetStatus}
        openInstrOverlay={this.props.gameStatus===GAME_STATUS_INSTR_OVERLAY}
        isRevealAnswers={this.props.gameStatus===GAME_STATUS_REVEAL_ALL_ANSWERS}
      />
    );
  }
}

const mapStateToProps = state => ({
  gameStatus: state.game.status,
  sounds: state.audio.sounds,
  points: state.game.points,
  bet: state.game.bet,
  betLocked: state.game.betLocked,
  focusLinkIndex: state.game.focusLinkIndex,
  isAllowHintOnFocusLink: state.game.isAllowHintOnFocusLink
});

const mapDispatchToProps = dispatch => ({
  setGameBet: data=>{
    dispatch(setGameBet(data));
  },
  setGameBetLock: ()=>{
    dispatch(setGameBetLock());
  },
  setShouldRewardPoints: data=>{
    dispatch(setShouldRewardPoints(data));
  },
  setGameRevealAllAnswersClickStatus: ()=>{
    dispatch(setGameRevealAllAnswersClickStatus());
  },
  setGameQuitStatus: ()=> {
    dispatch(setGameQuitStatus());
  },
  setGameHintStatus: ()=>{
    dispatch(setGameHintStatus());
  },
  setGameResetStatus: ()=> {
    dispatch(setGameStatus(null));
  },
});

BettingContainer.propTypes = {
  // quizQuestions: PropTypes.array.isRequired,
  // showAnswer: PropTypes.bool.isRequired,
  // index: PropTypes.number.isRequired,
  // onAnswerSelected: PropTypes.func.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BettingContainer);



// WEBPACK FOOTER //
// ./src/containers/ChainReactionGame/BettingContainer.js